export default __webpack_public_path__ + "static/media/bar-chart.af0a99aa.svg";